module.exports = __webpack_public_path__ + "img/link_icon.1082600a.png";